// Audit #8 (MEDIUM): the persisted complianceSteps held only the
// ExceptionCard-injected §9.6 step, while the full buildComplianceSteps output
// was rendered live by ComplianceSteps.tsx (display-only) and never reached
// the PDF (pdfExport reads plan.complianceSteps only).
//
// buildMergedComplianceSteps merges the auto-built §6 steps with the
// ExceptionCard-injected steps, deduping by ref — an injected step WINS over
// the auto step with the same ref (its status/evidence is the live-editable
// record). Used at save/export time in CreateConstructionPlanPage.
import { buildComplianceSteps } from './complianceSteps';
import type { ClassificationResult, ComplianceStep, LiftDetail } from '@/types/planData';

export function buildMergedComplianceSteps(
  classification: ClassificationResult | null,
  liftDetails: LiftDetail[],
  jhaReference: string | null,
  injectedSteps: ComplianceStep[]
): ComplianceStep[] {
  const auto = buildComplianceSteps(classification, liftDetails, { jhaReference });
  const injectedByRef = new Map(injectedSteps.map((s) => [s.ref, s]));
  const seen = new Set<string>();
  const merged: ComplianceStep[] = [];
  // Auto steps first (stable §6 order); skip refs overridden by an injected step.
  for (const step of auto) {
    if (injectedByRef.has(step.ref)) continue;
    if (seen.has(step.ref)) continue;
    seen.add(step.ref);
    merged.push(step);
  }
  // Injected steps last (ExceptionCard record with its live status/evidence).
  for (const step of injectedSteps) {
    if (seen.has(step.ref)) continue;
    seen.add(step.ref);
    merged.push(step);
  }
  return merged;
}
